/**
 * @Description
 */

export interface ModelClusterInfo {
  modelClusterId: number;
  modelClusterName: string;
  centerAddress: string;
  lng: number;
  lat: number;
  provinceName: string;
  cityName: string;
  districtName: string;
  levelCategoryName: string;
  radius: number;
  borders?: any[];
  resourceMallFlag: boolean;
}

// 图形样式
export const clusterStyleConfig = {
  strokeColor: '#0A9999',
  strokeOpacity: 1,
  strokeWeight: 2,
  strokeStyle: 'dashed',
  fillColor: '#07B4B4',
  fillOpacity: 0.2,
};
